import { Injectable } from '@angular/core';
import { PrintLabelingDataService } from '@project/components/label/print-labeling/print-labeling-data.service';
import { PrintLabelingGenerator } from '@project/components/label/print-labeling/print-labeling-generator';
import { ProjectModel } from '@project/model/project.model';
import { BackgroundTasksInfoService } from '@project/service/background-tasks-info.service';
import { AlertHelper } from '@shared/alert/alert.helper';
import { AlertButton } from '@shared/alert/alertButton';
import { FileUtils } from '@shared/util/file-utils';
import { lastValueFrom } from 'rxjs';

export type PrintConverterResponse = {
  content: string,
  fileName: string,
  errorMessage: string,
}

@Injectable({
  providedIn: 'root'
})
export class PrintConverterService {

  constructor(
    public printLabelingGenerator: PrintLabelingGenerator,
    private projectModel: ProjectModel,
    private alertHelper: AlertHelper,
    private backgroundTasksInfoService: BackgroundTasksInfoService,
    private printLabelingDataService: PrintLabelingDataService,
  ) {
  }


  public async exportDirectPrintingsToPdf(): Promise<void> {
    await this.backgroundTasksInfoService.doWithTaskIndicator('printconverter-export',
      async () => {
        const printLabelingVO = this.printLabelingGenerator.createPrintLabelingVOForDirectPrinting();
        const projectName = this.projectModel.currentProject.name;
        const responses = await lastValueFrom(this.printLabelingDataService.downloadDirectPrintingPdfs(printLabelingVO, projectName));

        if (responses.length == 0) {
          await this.alertHelper.showError('printConverter.title.bad_request', 'printConverter.message.error_no_stripblocks_found');
          return;
        }

        for (const response of responses) {
          if (response.errorMessage) {
            await this.alertHelper.showError('printConverter.title.bad_request', response.errorMessage);
            return;
          }
        }

        const answer = await this.alertHelper.showAlert(
          'printConverter.title.success',
          'printConverter.message.success', undefined, [AlertButton.OK, AlertButton.CANCEL],
          'info',
          null,
          true,
          true,
        );

        if (answer == AlertButton.OK) {
          await FileUtils.saveFilesAsZip(responses.map(r => ({
            fileName: r.fileName,
            fileContent: r.content,
            fileExtension: '.pdf',
            isDecodingRequired: true,
          })), projectName);
        }
      })

  }
}
